import React from 'react';

const Quote = () => (
  <div className="quoteContainer">
    <p className="quoteText">
      Mathematics is not about numbers, equations, computations, or algorithms:
      it is about understanding.
    </p>
    <p className="quoteText">
      - William Paul Thurston
    </p>
  </div>
);

export default Quote;
